query UsageData(
    $daysAmountFilter: ConditionInt
    $daysAmountx2Filter: ConditionInt
    $textSearch: wsdk_test_runsSearchInsensitive
    $environmentCustomFieldsFilter: ConditionStringArray
    $environmentsFilter: ConditionString
    $flowsFilter: ConditionString
    $flowsCustomFieldsFilter: ConditionStringArray
    $otherCustomFieldsFilter: ConditionStringArray
    $unitIdCustomFieldsFilter: ConditionStringArray
    $environmentsEqAnyItem: ConditionString
    $environmentCustomFieldsNeTupleKey: ConditionString
    $unitIdCustomFieldsNeTupleKey: ConditionString
) {
    last_n_days: wsdk_test_runs(
        run_time_last_n_days: $daysAmountFilter,
        text_contains: $textSearch,
        and: [
            {
                or: [
                    { custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter },
                    { environments_eq_any_item: $environmentsFilter },
                    {
                        and: [
                            { custom_fields_ne_tuple_key: $environmentCustomFieldsNeTupleKey }
                            { environments_eq_any_item: $environmentsEqAnyItem }
                        ]
                    }
                ]
            },
            {
                or: [
                    { flows_eq_any_item: $flowsFilter },
                    { custom_fields_eq_any_item_for_any_value: $flowsCustomFieldsFilter },
                    { custom_fields_eq_any_item_for_any_value: $otherCustomFieldsFilter }
                ]
            },
            {
                or: [
                    { custom_fields_eq_any_item_for_any_value: $unitIdCustomFieldsFilter }
                    { custom_fields_ne_tuple_key: $unitIdCustomFieldsNeTupleKey }
                ]
            }
        ]
    ) {
        run_id_count
        total_pages_sum
    }
    last_2n_days: wsdk_test_runs(
        run_time_last_n_days: $daysAmountx2Filter,
        text_contains: $textSearch,
        and: [
            {
                or: [
                    { custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter },
                    { environments_eq_any_item: $environmentsFilter },
                    {
                        and: [
                            { custom_fields_ne_tuple_key: $environmentCustomFieldsNeTupleKey }
                            { environments_eq_any_item: $environmentsEqAnyItem }
                        ]
                    }
                ]
            },
            {
                or: [
                    { flows_eq_any_item: $flowsFilter },
                    { custom_fields_eq_any_item_for_any_value: $flowsCustomFieldsFilter },
                    { custom_fields_eq_any_item_for_any_value: $otherCustomFieldsFilter }
                ]
            },
            {
                or: [
                    { custom_fields_eq_any_item_for_any_value: $unitIdCustomFieldsFilter }
                    { custom_fields_ne_tuple_key: $unitIdCustomFieldsNeTupleKey }
                ]
            }
        ]
    ) {
        run_id_count
        total_pages_sum
    }
}

query RecentUsageData(
    $daysAmountFilter: ConditionInt
    $daysAmountx2Filter: ConditionInt
    $textSearch: wsdk_latest_test_runsSearchInsensitive
    $environmentCustomFieldsFilter: ConditionStringArray
    $environmentsFilter: ConditionString
    $flowsFilter: ConditionString
    $flowsCustomFieldsFilter: ConditionStringArray
    $otherCustomFieldsFilter: ConditionStringArray
    $unitIdCustomFieldsFilter: ConditionStringArray
    $environmentCustomFieldsNeTupleKey: ConditionString
    $unitIdCustomFieldsNeTupleKey: ConditionString
    $environmentsEqAnyItem: ConditionString
) {
    last_n_days: wsdk_latest_test_runs(
        run_time_last_n_days: $daysAmountFilter,
        text_contains: $textSearch,
        and: [
            {
                or: [
                    { custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter },
                    { environments_eq_any_item: $environmentsFilter },
                    {
                        and: [
                            { custom_fields_ne_tuple_key: $environmentCustomFieldsNeTupleKey }
                            { environments_eq_any_item: $environmentsEqAnyItem }
                        ]
                    }
                ]
            },
            {
                or: [
                    { flows_eq_any_item: $flowsFilter },
                    { custom_fields_eq_any_item_for_any_value: $flowsCustomFieldsFilter },
                    { custom_fields_eq_any_item_for_any_value: $otherCustomFieldsFilter }
                ]
            },
            {
                or: [
                    { custom_fields_eq_any_item_for_any_value: $unitIdCustomFieldsFilter },
                    { custom_fields_ne_tuple_key: $unitIdCustomFieldsNeTupleKey }
                ]
            }
        ]
    ) {
        run_id_count
        total_pages_sum
    }
    last_2n_days: wsdk_latest_test_runs(
        run_time_last_n_days: $daysAmountx2Filter,
        text_contains: $textSearch,
        and: [
            {
                or: [
                    { custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter },
                    { environments_eq_any_item: $environmentsFilter },
                    {
                        and: [
                            { custom_fields_ne_tuple_key: $environmentCustomFieldsNeTupleKey }
                            { environments_eq_any_item: $environmentsEqAnyItem }
                        ]
                    }
                ]
            },
            {
                or: [
                    { flows_eq_any_item: $flowsFilter },
                    { custom_fields_eq_any_item_for_any_value: $flowsCustomFieldsFilter },
                    { custom_fields_eq_any_item_for_any_value: $otherCustomFieldsFilter }
                ]
            },
            {
                or: [
                    { custom_fields_eq_any_item_for_any_value: $unitIdCustomFieldsFilter }
                    { custom_fields_ne_tuple_key: $unitIdCustomFieldsNeTupleKey }
                ]
            }
        ]
    ) {
        run_id_count
        total_pages_sum
    }
}
